import React from "react";
import { ChannelContext } from "../contexts";
import "../assets/styles/socials.sass";
import Utility from "../Utility";
import { Link } from "react-router-dom";
const Socials = ({ content }) => {
  const socialsList = (
    <ChannelContext.Consumer>
      {(currentChannel) => {
        const socList = Utility.getChannelSocials(content, currentChannel);
        if (!socList || socList.length === 0) return null;
        return socList.map((social, index) =>
          social.innerLink ? (
            <Link
              key={index}
              to={social.url}
              className="ur-mini-social"
              style={{
                backgroundImage: `url(${social.imageUrl})`,
              }}
            ></Link>
          ) : (
            <a
              key={index}
              href={social.url}
              className="ur-mini-social"
              target="_blank"
              style={{
                backgroundImage: `url(${social.imageUrl})`,
              }}
            ></a>
          )
        );
      }}
    </ChannelContext.Consumer>
  );
  return <div className="ur-mini-socials">{socialsList}</div>;
};
export default Socials;
